import { DEFAULT_GC_TIME, DEFAULT_STALE_TIME } from '@/client/constants';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import useGetQueryFn from '../use-get-query-fn';

export interface MediaLibraryItem {
  library_id: string;
  media_id: string;
  filename: string;
  mime_type: string;
  size: number;
  tags: string[];
  description?: string | null;
  uploaded_by?: string;
  uploaded_at: number;
}

type QueryResponse = {
  status: number;
  data: {
    media: MediaLibraryItem[];
    total_count: number;
    limit: number;
    offset: number;
  };
};

export const createListMediaLibraryKey = (additional: any[] = []) => [
  'list-media-library',
  ...additional,
];

export const useListMediaLibraryQuery = (additionalProps = {}) => {
  const queryFn = useGetQueryFn<QueryResponse>({
    defaultErrorMessage: 'An unexpected error occurred while listing the media library',
    endpoint: `/api/admin/whatsapp/media-library`,
  });

  return useQuery({
    queryKey: createListMediaLibraryKey([additionalProps]),
    queryFn: () => queryFn({ ...additionalProps }),
    staleTime: DEFAULT_STALE_TIME,
    gcTime: DEFAULT_GC_TIME,
    placeholderData: keepPreviousData,
  });
};
